import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthService } from '../service/auth.service';
import RoutePaths from './RoutePaths';

export const ProtectedRoute = ({ children }: { children: ReactElement }) => {
  const token = sessionStorage.getItem('user-token') || '';
  let accessToken = { AccessToken: '' };
  const location = useLocation();

  if (token) {
    accessToken = JSON.parse(token);
  }

  let authState = true;
  if (!accessToken?.AccessToken) {
    authState = false;
  }

  if (!authState && !location?.search) {
    return <Navigate to={RoutePaths.Root} />;
  }

  return children;
};

export async function loader({ request }: { request: any; params: any }) {
  const url = new URL(request.url);
  const search = url.searchParams.get('code');
  const isSlackConnecting = sessionStorage.getItem('slackConnecting') === 'true';

  const token = sessionStorage.getItem('user-token') || '';
  let accessToken = { AccessToken: '' };

  if (token) {
    accessToken = JSON.parse(token);
  }

  if (search && !accessToken?.AccessToken && !isSlackConnecting) {
    try {
      const res = await AuthService.ms_login(search || '', process.env.REACT_APP_REDIRECT || '');

      if (res) {
        const huddleInfo = await AuthService.huddle_info(res.AuthenticationResult?.IdToken);
        console.log(
          huddleInfo,
          'huddle info',
          huddleInfo?.isSlackLinked,
          JSON.stringify(huddleInfo?.isSlackLinked),
        );

        sessionStorage.setItem('SFToken', JSON.stringify(huddleInfo?.isSFLinked));

        sessionStorage.setItem('isSlackConnected', JSON.stringify(huddleInfo?.isSlackLinked));
        sessionStorage.setItem('organizationId', res?.organizationId ?? '');
        sessionStorage.setItem('organizationName', res?.organizationName ?? '');
        sessionStorage.setItem('current-user', res.email);
        sessionStorage.setItem('ms_login', res.isMSLogin);
        sessionStorage.setItem('user-token', JSON.stringify(res.AuthenticationResult));
        sessionStorage.setItem('user-name', `${res.firstName}`);
        sessionStorage.setItem('user-permissions', JSON.stringify(res?.permissions ?? []));
        sessionStorage.setItem('is-super-admin', String(Boolean(res?.isSuperAdmin)));
        const now = new Date();
        const fiveHoursLater = new Date(now.getTime() + 60 * 60 * 1000 * 5);
        const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
        sessionStorage.setItem('loginExpiry', fiveHoursLater.toString());
        sessionStorage.setItem('refreshToken', oneHourLater.toString());
      }
    } catch (err: any) {
      console.log(err);
    }
  }

  return null;
}
